/* eslint react/jsx-no-bind:0 */
import React, { Component } from "react"
import { Row, Col, Table, MenuItem, DropdownButton } from "react-bootstrap";
import Dialog from 'react-bootstrap-dialog'
import { PropTypes } from "prop-types"
import { connect } from "react-redux"
import { red, blue, green, lightgray } from '../../../../utils/constants'

class Alternates extends Component {
  constructor() {
    super();
    this.state = {
      alternates: []
    }
    this.handleOnDeleteAlternate = this.handleOnDeleteAlternate.bind(this)
    this.handleAddAlternate = this.handleAddAlternate.bind(this)
    this.handleUpdateAlternate = this.handleUpdateAlternate.bind(this)
    this.handleMoveUp = this.handleMoveUp.bind(this)
    this.handleMoveDown = this.handleMoveDown.bind(this)
  }
  handleMoveUp(alternateId) {
    const { alternates, onMoveUp } = this.props
    let alternateList = [];
    const newAlternateList = [];
    let holdOneAddedDate;
    let holdTwoDateAdded;
    let holdAlternateOne;
    let holdAlternateTwo;
    alternateList = alternates;
    for (let i = 0; i < alternateList.length; i++) {
      if (i > 0) { 
        if (alternateList[i].id === alternateId) {
          holdAlternateOne = alternateList[i - 1];
          holdAlternateTwo = alternateList[i];
          holdOneAddedDate = holdAlternateOne.dateAdded;
          holdTwoDateAdded = holdAlternateTwo.dateAdded;
          const holdAlternateOneId = holdAlternateOne.id;
          alternateList[i] = holdAlternateOne;
          alternateList[i - 1] = holdAlternateTwo; 
          alternateList[i].id = alternateId;
          alternateList[i - 1].id = holdAlternateOneId;
          alternateList[i - 1].dateAdded = holdOneAddedDate;
          alternateList[i].dateAdded = holdTwoDateAdded;
          newAlternateList[0] = alternateList[i - 1];
          newAlternateList[1] = alternateList[i];
           break; 
        }
      }
    }
    if (newAlternateList.length > 1) {
      onMoveUp(newAlternateList);
    }
    this.setState({
      alternates: alternateList
    });
  }

  handleMoveDown(alternateId) {
    const { alternates, onMoveDown } = this.props
    let alternateList = [];
    const newAlternateList = [];
    let holdOneAddedDate;
    let holdTwoDateAdded;
    let holdAlternateOne;
    let holdAlternateTwo;
    alternateList = alternates;
    for (let i = 0; i < alternateList.length; i++) {
      if (i < alternateList.length - 1) {
        if (alternateList[i].id === alternateId) {
          holdAlternateOne = alternateList[i + 1];
          holdAlternateTwo = alternateList[i];
          holdOneAddedDate = holdAlternateOne.dateAdded;
          holdTwoDateAdded = holdAlternateTwo.dateAdded;
          const holdAlternateOneId = holdAlternateOne.id;
          alternateList[i] = holdAlternateOne;
          alternateList[i + 1] = holdAlternateTwo;
          alternateList[i].id = alternateId;
          alternateList[i + 1].id = holdAlternateOneId;
          alternateList[i + 1].dateAdded = holdOneAddedDate;
          alternateList[i].dateAdded = holdTwoDateAdded;
          newAlternateList[0] = alternateList[i + 1];
          newAlternateList[1] = alternateList[i];
          break;
        }
      }
    }
    if (newAlternateList.length > 1) {
      onMoveDown(newAlternateList);
    }
    this.setState({
      alternates: alternateList
    });
  }
  handleAddAlternate() {
    const { onAddAlternate } = this.props
    onAddAlternate();
  }
  handleUpdateAlternate(alternateId) {
    const { onUpdateAlternate } = this.props;
    onUpdateAlternate(alternateId);
  }
  handleOnDeleteAlternate(alternateId) {
    const customBody = (
      <p>
        <i className="fa fa-exclamation-triangle text-danger" style={{ color: 'red' }} />
        &nbsp;&nbsp;
        <span>Are you sure you want to remove this alternate? </span>
      </p>
    )

    Dialog.setOptions({
      defaultOkLabel: 'Remove',
      defaultCancelLabel: 'Cancel',
      primaryClassName: 'btn-danger'
    })
    Dialog.Action(
      'Remove Alternate',
      () => this.props.onDeleteAlternate(alternateId),
      'btn-danger'
    )
    this.dialog.show({
      body: customBody,
      title: 'Confirm Alternate removal',
      actions: [
        Dialog.CancelAction(),
        Dialog.OKAction(() => this.props.onDeleteAlternate(alternateId))
      ],
      bsSize: 'small'
    })
  }

  render() {
    const { alternates, numberSpots, disabled, roleName, alternateUpdateInfo } = this.props
    if (alternateUpdateInfo.memberType == 'updatedAlternate') {
      for (let i = 0; i < alternates.length; i++) {
        const dateOfBirth = new Date(alternateUpdateInfo.alternate.dob);
        let month = (dateOfBirth.getMonth() + 1);
        month = month > 9 ? month : '0' + month;
        let day = dateOfBirth.getDate();
        day = day > 9 ? day : '0' + day;
        const convertedDob = month + "/" + day + "/" + dateOfBirth.getFullYear();
        if (alternates[i].id === alternateUpdateInfo.alternate.alternateId) {
          alternates[i].calculatedDivision = alternateUpdateInfo.alternate.calculatedDivision;
          alternates[i].divisionId = alternateUpdateInfo.alternate.divisionId;
          alternates[i].dob = convertedDob;
          alternates[i].firstName = alternateUpdateInfo.alternate.firstName;
          alternates[i].lastName = alternateUpdateInfo.alternate.lastName;
          alternates[i].middleInitial = alternateUpdateInfo.alternate.middleInitial;
          alternates[i].addressLine1 = alternateUpdateInfo.alternate.addressLine1;
          alternates[i].addressLine2 = alternateUpdateInfo.alternate.addressLine2;
          alternates[i].city = alternateUpdateInfo.alternate.city;
          alternates[i].country = alternateUpdateInfo.alternate.country;
          alternates[i].state = alternateUpdateInfo.alternate.state;
          alternates[i].zip = alternateUpdateInfo.alternate.zip;
          alternates[i].emailAddress = alternateUpdateInfo.alternate.emailAddress;
          alternates[i].gender = alternateUpdateInfo.alternate.gender;
          alternates[i].membershipId = alternateUpdateInfo.alternate.membershipId;
          alternates[i].phoneNumber = alternateUpdateInfo.alternate.phoneNumber;
          alternates[i].parentGuardianEmail = alternateUpdateInfo.alternate.parentGuardianEmail;
          break;
        }
      }
    }
    const isAdministrator = roleName == 'Administrator';
    return (
      <div style={{ backgroundColor: 'white', padding: '10px', border: `1px solid ${lightgray}` }}>
        <Row>
          <Col xs={12}>
            <h4>Alternates</h4>
            <h4 style={{ color: blue, textDecoration: 'underline' }}>Minimum number of alternates: {numberSpots}</h4>
            <button type='button' className="btn btn-default" style={{ color: green, fontWeight: 800, marginLeft: '10px', float: 'right' }}
              onClick={this.handleAddAlternate} disabled={disabled}>
              <i className="fa fa-plus" aria-hidden="true" /> &nbsp;&nbsp;Add Alternate
            </button>
            <Dialog ref={(el) => { this.dialog = el }} />
            <Table striped>
              <thead>
                <tr>
                  <th />
                  <th>Name</th>
                  <th>Membership ID</th>
                  <th>Date of Birth</th>
                  <th>Calculated Division</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {
                  alternates.map((item, key) => (
                    <tr key={key}>
                      <td>{key + 1}</td>
                      <td>{item.firstName + " " + item.lastName}</td>
                      <td>{item.membershipId}</td>
                      <td>{item.dob}</td>
                      <td>{item.calculatedDivision}</td>
                      <td>
                        {
                          !isAdministrator &&

                          <button type='button' className="btn btn-default" style={{ color: red, fontWeight: 800 }} onClick={() => this.handleOnDeleteAlternate(item.id)} disabled={disabled}>
                            <i className="fa fa-remove" aria-hidden="true" /> &nbsp;&nbsp;Remove
                          </button>
                        }
                        {
                          isAdministrator && this.state.alternates.length !== -1 &&
                          <DropdownButton pullRight noCaret title={<i className="fa fa-angle-right" />} id={"cloneActionBtn" + key}>
                            {
                              <div style={{ textAlign: 'left', paddingLeft: '10px' }}>
                                <MenuItem>
                                  <span style={{ color: red, fontWeight: 800 }} onClick={() => this.handleOnDeleteAlternate(item.id)}>
                                    <i className="fa fa-remove  text-muted mr-sm" style={{ color: red }} />&nbsp;Remove
                                  </span>
                                </MenuItem>
                                <MenuItem>
                                  <span style={{ color: blue, fontWeight: 800 }} onClick={() => this.handleUpdateAlternate(item.id)}>
                                    <i className="fa fa-refresh text-muted mr-sm" style={{ color: blue }} />&nbsp;Update
                                  </span>
                                </MenuItem>
                                <MenuItem>
                                  <span style={{ color: green, fontWeight: 800 }} onClick={() => this.handleMoveUp(item.id)}>
                                    <i className="fa fa-angle-up  text-muted mr-sm" style={{ color: green }} />&nbsp;Move Up
                                  </span>
                                </MenuItem>
                                <MenuItem>
                                  <span style={{ color: green, fontWeight: 800 }} onClick={() => this.handleMoveDown(item.id)}>
                                    <i className="fa fa-angle-down  text-muted mr-sm" style={{ color: green }} />&nbsp;Move Down
                                  </span>
                                </MenuItem>
                              </div>
                            }
                          </DropdownButton>
                        }
                      </td>
                    </tr>
                  ))
                }
              </tbody>
            </Table>
          </Col>
        </Row>
      </div>
    );
  }
}

Alternates.propTypes = {
  onDeleteAlternate: PropTypes.func,
  onAddAlternate: PropTypes.func,
  onUpdateAlternate: PropTypes.func,
  alternateUpdateInfo: PropTypes.array,
  onMoveUp: PropTypes.func,
  onMoveDown: PropTypes.func,
  alternates: PropTypes.array,
  numberSpots: PropTypes.number,
  disabled: PropTypes.bool,
  roleName: PropTypes.string
}
function mapStateToProps(state) {
   
  const roleName = state.user.roleName
  return {
    roleName
  }
}
export default connect(mapStateToProps)(Alternates)



// WEBPACK FOOTER //
// ./src/containers/postevent/components/recordAthletes/alternates.js